import { createAction } from '@src/redux/helpers/createAction';
import { GET_USER_INFO, VALIDATE_USER } from './constants';
import { getUserInfoRequest, validateUserRequest } from './requests';

export const getUserInfo = (onSuccess, onError) => {
  return createAction({
    type: GET_USER_INFO,
    meta: {
      onSuccess,
      onError,
      async: getUserInfoRequest,
    },
  });
};

export const validateUser = (onSuccess, onError) => {
  return createAction({
    type: VALIDATE_USER,
    cache: false,
    meta: {
      onSuccess,
      onError,
      async: validateUserRequest,
    },
  });
};
